<template>
  <div>
    <div class="text-h6 q-mb-md">{{ resource.title }}</div>
    <div v-if="isVideo" class="youtube-embed-container">
      <!-- eslint-disable -->
      <iframe
        :src="resource.src"
        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
    </div>
    <p v-else>
      <q-btn
        type="a"
        :href="resource.src"
        target="_blank"
        :icon="resource.icon"
        label="View"
        flat />
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import "../styles/quasar.variables";
.youtube-embed-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.5%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: $breakpoint-sm) {
    position: relative;
    height: auto;
    padding-bottom: 0;

    iframe {
      position: static;
      width: 560px;
      height: 315px;
    }
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { Resource } from '.';

export default defineComponent({
  props: {
    resource: Object as () => Resource,
  },
  computed: {
    isVideo(): boolean {
      return (this.resource.type === 'video');
    },
  },
});
</script>
